import React, { Component } from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";
import Subscription from "~/models/Subscription/Subscription";
import OtherProduct from "~/models/OtherProduct";
import SubscriptionCardHeader from "~/modules/BillingCentral/components/SubscriptionCardHeader";
import SubscriptionCancelAtPeriodEndCardDescription from "~/modules/BillingCentral/components/SubscriptionCancelAtPeriodEndCardDescription";
import SubscriptionStatusInactiveCardContext from "~/modules/BillingCentral/components/SubscriptionStatusInactiveCardContext";
import OtherProductCard from "~/modules/BillingCentral/components/OtherProductCard";

@observer
class SimpleActiveSubscriptionCard extends Component {
  @computed
  get selectedOtherProductIds() {
    const { otherProducts } = this.props;

    const selectedOtherProductIds = [];

    otherProducts.forEach(otherProduct => {
      selectedOtherProductIds.push(otherProduct.otherProductId);
    });

    return selectedOtherProductIds;
  }

  getOtherProduct(otherProducts, otherProductId) {
    const otherProduct = otherProducts.find(item => item.otherProductId === otherProductId);

    return typeof otherProduct !== "undefined" ? otherProduct : null;
  }

  render() {
    const { subscription, otherProducts } = this.props;

    const orderedByOtherProductIdSubscriptionItems = []
      .concat(subscription.nextBillingCycleSubscriptionItems)
      .sort((a, b) => (a.otherProductId > b.otherProductId ? 1 : -1));

    return (
      <Card fluid>
        <Card.Content>
          <SubscriptionCardHeader subscription={subscription} />
          <SubscriptionCancelAtPeriodEndCardDescription subscription={subscription} />
        </Card.Content>
        <SubscriptionStatusInactiveCardContext subscription={subscription} />
        <Card.Content extra>
          <Card.Group>
            {orderedByOtherProductIdSubscriptionItems.map(subscriptionItem => (
              <OtherProductCard
                key={subscriptionItem.otherProductId}
                otherProduct={this.getOtherProduct(otherProducts, subscriptionItem.otherProductId)}
                selectedOtherProductIds={this.selectedOtherProductIds}
                quantity={subscriptionItem.quantity}
              />
            ))}
          </Card.Group>
        </Card.Content>
      </Card>
    );
  }
}

SimpleActiveSubscriptionCard.propTypes = {
  subscription: PropTypes.instanceOf(Subscription),
  otherProducts: PropTypes.arrayOf(PropTypes.instanceOf(OtherProduct)),
};

export default SimpleActiveSubscriptionCard;
